import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideTranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import Material from '@primeng/themes/material';
import {definePreset} from "@primeng/themes";
import Aura from '@primeng/themes/aura'; // ou Material, Lara, Nora…

const MaterialLightIndigo = definePreset(Material, {
  semantic: {
    primary: {
      50:  '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideTranslateService(),
    provideRouter(routes),
    provideHttpClient(
      // withInterceptors([UrlUpdateInterceptor])
    ),
    MessageService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MaterialLightIndigo,
        options: {
          // darkModeSelector: false,
          prefix: 'p',
          darkModeSelector: '.primeng-dark-mode',
          cssLayer: false,
        }
      },
      ripple: true,
    }),
    importProvidersFrom(BrowserAnimationsModule),
  ]
};
